import { createContext, Dispatch, useCallback, useReducer } from "react";
import { removeTokens, setCompanyId, setCompanyName } from "../utils/cacheStorage";

interface AuthState {
  user: any;
  userCompany: string | null;
  newNotification: any;
  token?: string | null;
  refreshToken?: string | null;
  company?: any;
}

const initialState: AuthState = {
  user: null,
  userCompany: null,
  newNotification: false,
  token: null,
  refreshToken: null,
  company: null
};

interface AuthContextProps extends AuthState {
  dispatch: Dispatch<AuthAction>;
  logout: () => void;
  setCompany: (companyName: string, companyId: string) => void;
}

type AuthAction =
  | { type: "LOGIN"; payload: any }
  | { type: "LOGOUT"; payload?: any }
  | { type: "SET_COMPANY"; payload: string }
  | { type: "SET_COMPANY_ID"; payload: string }
  | { type: "NEW_NOTIFICATION"; payload?: boolean };

export const AuthContext = createContext<AuthContextProps>({
  ...initialState,
  dispatch: () => {},
  logout: () => {},
  setCompany: () => {}
});

export const authReducer = (state: AuthState, action: AuthAction): AuthState => {
  switch (action.type) {
    case "LOGIN":
      return { ...state, user: action.payload };
    case "LOGOUT":
      return {
        ...initialState
      };
    case "SET_COMPANY":
      setCompanyName(action.payload);
      return { ...state, userCompany: action.payload };
    case "SET_COMPANY_ID":
      setCompanyId(action.payload);
      return { ...state, userCompany: action.payload };
    case "NEW_NOTIFICATION":
      return { ...state, newNotification: Math.random() };
    default:
      return state;
  }
};

export const AuthContextProvider = ({ children }: any) => {
  const [state, dispatch] = useReducer(authReducer, initialState);

  const logout = useCallback(() => {
    removeTokens();
    dispatch({ type: "LOGOUT" });
  }, []);

  const setCompany = useCallback((companyName: string, companyId: string) => {
    setCompanyName(companyName);
    dispatch({ type: "SET_COMPANY", payload: companyName });
    dispatch({ type: "SET_COMPANY_ID", payload: companyId });
  }, []);

  return (
    <AuthContext.Provider value={{ ...state, dispatch, logout, setCompany }}>
      {children}
    </AuthContext.Provider>
  );
};
